import Glass from './imgs/glass.png';

const GlassData = [
    {
        id:"1",
        imgsrc: Glass,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"2",
        imgsrc: Glass,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"3",
        imgsrc: Glass,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"4",
        imgsrc: Glass,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"5",
        imgsrc: Glass,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"6",
        imgsrc: Glass,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"7",
        imgsrc: Glass,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"8",
        imgsrc: Glass,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"9",
        imgsrc: Glass,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"10",
        imgsrc: Glass,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
];

export default GlassData;